module.exports = __webpack_public_path__ + "img/anniu2ac.fdaa797f.png";